const tableOfContentsSlideUp = (target, duration=500) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
    }, duration);
}
const tableOfContentsSlideDown = (target, duration=500) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none')
        display = 'block';

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 15 + 'px';
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    // target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}
const StringToSlug = (str)  => {
    // lower case all string
    str = str.toLowerCase();
    str = str
        .normalize('NFD') // convert to unicode
        .replace(/[\u0300-\u036f]/g, ''); // remove all accents

    // replace đĐ
    str = str.replace(/[đĐ]/g, 'd');

    str = str.replace(/([^0-9a-z-\s])/g, '');

    // replace space to -
    str = str.replace(/(\s+)/g, '-');
    str = str.replace(/-+/g, '-');
    str = str.replace(/^-+|-+$/g, '');

    return str;
};
const tableOfContentsSlideToggle = (target, duration = 500) => {
    if (window.getComputedStyle(target).display === 'none') {
        return tableOfContentsSlideDown(target, duration);
    } else {
        return tableOfContentsSlideUp(target, duration);
    }
}
const tableOfContents=function(e,t,r){const n=document.querySelector(e),l=document.querySelector(t);if(n&&l){let a,i,o,c,h={levels:"h2, h3, h4, h5, h6",headingLevel:"h2",listType:"ul"},u={},p=function(e){for(var t="",r=0;r<e;r++)t+="</"+u.listType+"></li>";return t},s=function(e,t){return e>0?function(e){for(var t="",r=0;r<e;r++)t+="<"+u.listType+">";return t}(e):e<0?p(Math.abs(e)):t&&!e?"</li>":""};(function(e){for(var t in h)Object.prototype.hasOwnProperty.call(h,t)&&(u[t]=Object.prototype.hasOwnProperty.call(e,t)?e[t]:h[t])})(r||{}),(a=n.querySelectorAll(u.levels)).length&&(i=a[0].tagName.slice(1),o=i,c=a.length-1,l.innerHTML="<"+u.headingLevel+"></"+u.headingLevel+"><"+u.listType+">"+Array.prototype.map.call(a,function(e,t){!function(e){e.id.length||(e.id=StringToSlug(e.textContent))}(e);var r=e.tagName.slice(1),n=r-i;i=r;var l=s(n,t);return l+='<li><a href="#'+e.id+'">'+e.innerHTML.trim()+"</a>",t===c&&(l+=p(Math.abs(o-r))),l}).join("")+"</"+u.listType+">")}};
